import { createSelector } from "reselect"
import { capitalize } from "lodash"
import { getViewType } from "."
import { getFactorCategoryId } from "./items"
import { getStartDate, getEndDate } from "./dates"

const getPositionSetName = (_, props) => props.positionSetName

export const getFileName = createSelector(
  [getPositionSetName, getFactorCategoryId, getViewType, getStartDate, getEndDate],
  (positionSetName, factorCategoryId, viewType, startDate, endDate) => `${positionSetName} ${capitalize(factorCategoryId)} ${capitalize(viewType)} Risk ${startDate} - ${endDate}`,
)
